import { render } from "./ImportXLSXFile.vue?vue&type=template&id=4e51d518&ts=true"
import script from "./ImportXLSXFile.vue?vue&type=script&lang=ts"
export * from "./ImportXLSXFile.vue?vue&type=script&lang=ts"

import exportComponent from "/home/adroneleh/projects/vue-js-matrix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__